import React, { Fragment, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
    Row,
    Col,
    Form,
    Button
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import CanvasDraw from "react-canvas-draw";

const ValidateAndSave = ({ setSteps, setFormdata, formdata,setTransactionId }) => {
    const {
        handleSubmit,
    } = useForm();
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current && formdata.damage_declaration) {
            canvasRef.current.loadSaveData(formdata.damage_declaration);
        }
    }, [formdata.damage_declaration]);

    const onSubmit = () => {
        processValet(formdata);
    };

    const processValet = (valetProcess) => {
        axios
            .post(`${process.env.REACT_APP_PUBLIC_SERVER}/api/vehicle`, valetProcess)
            .then((response) => {
                toast.success("¡Proceso guardado exitosamente!");
                setTransactionId(response.data.id);
                setSteps((prev) => prev + 1);
            })
            .catch((error) => {
                toast.error("Error al guardar el proceso: " + error.message);
            });
    };

    const onBack = () => {
        setSteps((prev) => prev - 1);
    };

    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                        <div>
                            <Col md="12 mb-3">
                                <h1 className="display-5">Validación Final</h1>
                                <p>Revisa la información. Si todo es correcto, presiona "Finalizar".</p>
                            </Col>

                            <div className="summary">
                                <div className="col-md-12"><h2>Resumen de la Información</h2></div>
                                <div className="col-md-6">
                                    <label className="form-control"><strong>ID del Valet:</strong> {formdata.valet_name || "No especificado"}</label>
                                    <label className="form-control"><strong>ID del Cliente:</strong> {formdata.full_name || "No especificado"}</label>
                                    <label className="form-control"><strong>ID de la Compañía:</strong> {formdata.id_company || "No especificado"}</label>
                                </div>
                                <div className="col-md-6">
                                <label className="form-control"><strong>Declaración de Objetos:</strong> {formdata.object_declaration || "No especificado"}</label>
                                    <label className="form-control"><strong>Declaración de Daños:</strong></label>
                                    <label className="form-control"><strong>GPS Inicial:</strong> {formdata.initial_gps || "No especificado"}</label>
                                </div>
                                <div className="col-md-12">
                                <CanvasDraw
                                    ref={canvasRef}
                                    canvasWidth={800}
                                    disabled={true}
                                    hideGrid={true}
                                    imgSrc={`${process.env.REACT_APP_PUBLIC_URL}/${formdata.car_type}.png`}
                                />
                                </div>

                            </div>

                            <div className="text-end btn-mb mt-3">
                                <Button color="secondary" className="me-2" onClick={onBack}>
                                    Anterior
                                </Button>
                                <Button color="primary" type="submit">
                                    Finalizar
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ValidateAndSave;
